import { useShowResponseStatus } from '@/shared';
import { useUpdateRemotePaymentMethodMutation } from '../store/remote-payment-methos-api';

import type { TRemotePaymentMethodUpdateParams } from '../store/types';

export const useUpdateRemoteMethod = () => {
  const [updateRemoteMethod, { isLoading, isSuccess, isError }] = useUpdateRemotePaymentMethodMutation();

  useShowResponseStatus({
    isSuccess,
    isError,
  });

  const handleRemoteMethodUpdate = async (params: TRemotePaymentMethodUpdateParams) => {
    await updateRemoteMethod(params);
  };

  return {
    handleRemoteMethodUpdate,
    updateRemoteMethod,
    isLoading,
  };
};
